export * from './header';
export * from './footer';
export * from './sidebar';
export * from './game-grid';
export * from './loading';
export * from './game';
export * from './mg-wallet';

export class MostPlayedComponent {
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/components/index.ts